@for (msg of messages(); track $index) {
  @if (msg.sender === 'user') {
    <app-user-message [message]="msg" [showTimestamp]="timestampIndexes().has($index)" />
  } @else {
    <app-agent-message [message]="msg" [isStreaming]="false" />
  }
}
@if (currentAgentMsg(); as msg) {
  <app-agent-message [message]="msg" [isStreaming]="true" />
}
